function caseInsensitiveComparison (str1, str2) {
    const a = str1.toLowerCase();
    const b = str2.toLowerCase();
    if(a < b) return -1;
    if(a > b) return 1;
    return 0;
}

function upperCaseFirstLetter(str) {
    return str[0].toUpperCase() + str.substring(1);
}

export { caseInsensitiveComparison, upperCaseFirstLetter };
